import React from 'react';
import Highcharts from 'highcharts';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HighchartsReact from 'highcharts-react-official';
import { Box, CircularProgress, Paper } from '@material-ui/core';
import PeriodicityButton from './utils/PeriodicityButton';
import ExportCsvButton from './utils/ExportCsvButton';
import { exportToCsv, exportToExcel } from './utils/csvExport';
import { getReceptionQuantities } from '../dashboardActions';

const ReceptionsChart = ({
  receptionQuantities,
  dispatchGetReceptionQuantities,
  loadingReceptionQuantities
}) => {
  const data = receptionQuantities.map(({ quantity, period }) => [
    period,
    quantity
  ]);

  const categories = [];

  data.forEach(item => {
    categories.push(item[0]);
  });

  const options = {
    chart: {
      type: 'spline'
    },
    title: {
      text: ''
    },
    xAxis: {
      categories
    },
    yAxis: {
      title: {
        text: ''
      }
    },
    credits: {
      enabled: false
    },
    series: [
      {
        color: '#4C76BB',
        name: 'Réceptionnées',
        data
      }
    ]
  };

  return (
    <Paper
      style={{
        paddingTop: 48,
        paddingLeft: 80,
        paddingRight: 80,
        borderRadius: 20
      }}
    >
      <Box
        display="flex"
        alignItems="baseline"
        justifyContent="space-between"
        mb={4}
      >
        <Box display="flex" alignItems="center">
          <Box fontSize={21} color="#001C56">
            Réceptions
          </Box>
          <ExportCsvButton
            onClick={() => {
              const columns = ['Période', 'Quantité réceptionnée'];
              const rows = receptionQuantities.map(r => [r.period, r.quantity]);
              exportToCsv('receptions', columns, rows);
            }}
            onExcelClick={() => {
              const columns = ['Période', 'Quantité réceptionnée'];
              const rows = receptionQuantities.map(r => [r.period, r.quantity]);
              exportToExcel('receptions', columns, rows);
            }}
          />
        </Box>
        <PeriodicityButton
          defaultPeriodicity="LAST_SIX_MONTH"
          onChange={({ dateFrom, dateTo }) => {
            dispatchGetReceptionQuantities({
              dateFrom,
              dateTo,
              period: 'month'
            });
          }}
        />
      </Box>
      {loadingReceptionQuantities ? (
        <Box display="flex" justifyContent="center" p={20}>
          <CircularProgress size={60} />
        </Box>
      ) : (
        <HighchartsReact highcharts={Highcharts} options={options} />
      )}
    </Paper>
  );
};

const mapStateToProps = state => ({
  receptionQuantities: state.dashboard.receptionQuantities,
  loadingReceptionQuantities: state.dashboard.loadingReceptionQuantities
});

const mapDispatchToProps = dispatch => ({
  dispatchGetReceptionQuantities: params =>
    dispatch(getReceptionQuantities(params))
});

ReceptionsChart.propTypes = {
  receptionQuantities: PropTypes.array,
  dispatchGetReceptionQuantities: PropTypes.func,
  loadingReceptionQuantities: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(ReceptionsChart);
